import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { StyledModalBody } from "../../../../../../components/Modals";
import { ButtonBodyVariant } from "../../../../../../components/ui/ButtonVariant";
import { useTranslation } from "react-i18next";
import { closeActiveModal, openModal } from "../../../../../../helper/modals";
import styled from "styled-components";
import { Flex } from "../../../../../../components/ui/Flex";
import { Fonts, Palette } from "../../../../../../components/utils";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../../../../../components/ui/Form";
import { useForm } from "react-hook-form";
import { Select, SelectItem } from "../../../../../../components/ui/Select";
import { SettingsModalInput } from "../../../../../settings/SettingsModals";
import { ModalButtonsContainer, PaymentModal, StepItem, LightBlueText, TitleText, CurrencyInputContainer } from "../../../../PaymentComponents";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { updatePaymentData } from "../../../../../../redux/actions/payments";
import { TextInput } from "../../../../../../components/ui/TextInput";

const schema = Yup.object().shape({
  amount: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Invalid Amount')
    .required('An amount is required')
    .max(10000, 'Amount exceeds the limit $10,000'),
  frequency: Yup.string('A frequency is required')
    .required('A damage deposit is required'),
  notes: Yup.string().optional(),
});

const CreateRecurringPaymentStep2 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modal = useSelector((state) => state.headerModal.modal);
  const addPayment = useSelector((state) => state.addPayment);

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      amount: addPayment.amount,
      frequency: addPayment.frequency,
      notes: addPayment.notes,
    }
  });

  const onSubmit = (values) => {
    dispatch(updatePaymentData(values))
    openModal('CreateRecurringPaymentStep3')
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <PaymentModal
          show={modal === 'CreateRecurringPaymentStep2'}
          onClose={closeActiveModal}
          closeOnBackdrop={false}
          width={'460px'}>
          <StyledModalBody>
            <Flex direction="column" gap="1rem">
              <Flex direction="column">
                <Flex justify="space-between" alignItems="center" style={{ width: "100%" }}>
                  <LightBlueText> STEP 2/3</LightBlueText>
                  <Flex gap="0.5rem">
                    <StepItem filled />
                    <StepItem filled />
                    <StepItem />
                  </Flex>
                </Flex>
                <TitleText>Select Payment Details</TitleText>
              </Flex>

              <Flex direction="column" alignItems="center" gap="1rem">
                <FormField
                  control={form.control}
                  name="amount"
                  render={({ field }) => (
                    <FormItem alt>
                      <FormLabel v3>{t('Amount')}</FormLabel>
                      <FormControl row>
                        <CurrencyInputContainer>
                          <TextInput
                            type="text"
                            placeholder={t('Amount')}
                            autoComplete="off"
                            {...field}
                          />
                        </CurrencyInputContainer>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="frequency"
                  render={({ field }) => (
                    <FormItem alt>
                      <FormLabel v3>{t('Frequency')}</FormLabel>
                      <FormControl row>
                        <Select
                          height="3rem"
                          {...field}>
                          {/* <SelectItem value={'single'}>{'Single'}</SelectItem> */}
                          <SelectItem value={'weekly'}>{'Weekly'}</SelectItem>
                          <SelectItem value={'monthly'}>{'Monthly'}</SelectItem>
                          {/* <SelectItem value={'semi-monthly'}>{'Semi-Monthly'}</SelectItem>
                          <SelectItem value={'yearly'}>{'Yearly'}</SelectItem> */}
                        </Select>
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />

                {/* <FormField
                  control={form.control}
                  name="notes"
                  render={({ field }) => (
                    <FormItem alt>
                      <FormLabel v3>{t('Notes')}</FormLabel>
                      <FormControl>
                        <SettingsModalInput
                          type="text"
                          placeholder={t('Notes')}
                          autoComplete="off"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                /> */}
              </Flex>
              <ModalButtonsContainer gapY="8px">
                <ButtonBodyVariant cssOverride="width: 8.875rem; height: 2rem;" variant="secondary" onClick={closeActiveModal}>{t('Cancel')}</ButtonBodyVariant>
                <ButtonBodyVariant cssOverride="width: 8.875rem; height: 2rem;" type="submit">{t('Next')}</ButtonBodyVariant>
              </ModalButtonsContainer>
            </Flex>
          </StyledModalBody>
        </PaymentModal>
      </form>
    </Form>
  )
}

export default CreateRecurringPaymentStep2
